import { useState } from 'react';

import { Chip, ChipProps, Tooltip } from '@mui/material';
import { GridRowModel } from '@mui/x-data-grid-pro';

import { ConfirmModal } from 'components/modal';

type LojaImportacaoStatusChip = {
    row: GridRowModel;
};

const colorError: { [key: number]: ChipProps['color'] } = {
    1: 'info',
    3: 'success',
    5: 'error',
} as const;

export function LojaImportacaoStatusChip({ row }: LojaImportacaoStatusChip) {
    const [open, setOpen] = useState<boolean>(false);
    const { idStatusProcessamento, dsStatusProcessamento, dsValidacao } = row;
    const hasError = idStatusProcessamento === 5 && dsValidacao;

    return (
        <>
            <ConfirmModal open={open} setOpen={setOpen} showCancel={false} text={dsValidacao} title="Falhas" confirmText="Ok" />

            <Tooltip title={hasError ? 'Visualizar falhas' : ''}>
                <Chip
                    size="small"
                    variant="outlined"
                    label={dsStatusProcessamento}
                    color={colorError[idStatusProcessamento]}
                    sx={{ width: 250 }}
                    onClick={() => hasError && setOpen(true)}
                />
            </Tooltip>
        </>
    );
}
